import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as convertKeys from 'convert-keys';
import { ApiService } from './api.service';
import { Channel, Utility } from '../model';

@Injectable()
export class ReferenceService {
  readonly utilities$ = new BehaviorSubject<Utility[]>(null);
  readonly channels$ = new BehaviorSubject<Channel[]>(null);

  constructor(private apiService: ApiService) {}

  async setUtilities(): Promise<void> {
    try {
      const utilities = await this.apiService.get('utilities', { per_page: '1000' });
      this.utilities$.next(convertKeys.toCamel(utilities));
    } catch (err) {
      console.log(`Could not load Utilities`, err);
      this.utilities$.next([]);
    }
  }

  async setChannels(): Promise<void> {
    try {
      const channels = await this.apiService.get('channels');
      this.channels$.next(convertKeys.toCamel(channels));
    } catch (err) {
      console.log(`Could not load Channels`, err);
    }
  }
}
